import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col } from 'antd';
import Button from 'components/Button';
import ImagemAtendente from 'assets/img/CadastrarAtendente.svg';
import InputText from 'components/InputText';
import InputSelect from 'components/InputSelect';
import Setorial from './setorial';
import { openModalConfirmacao } from 'components/Modal/ModalConfirmacao';
import { fetchDeletarAtendente, fetchGetAtendenteById, fetchAtendenteLogado } from 'store/fetchActions/fetchAtendente';
import { cpfMask } from 'utils/masks';
import { editarAtendente } from 'routes/paths';
import { ENUM_CARGO } from 'utils/consts';
import {
  verificarOptionsSetores,
  verificarPermissaoEditarApagar,
  validarCargo,
  getMensagem,
  filtrarSetores,
} from './FormAtendente';
import * as Style from 'components/Style';
import * as S from '../styles';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';
import { altImageAtendente } from 'utils/acessibilidade';

export default function FormAtendente({
  errors,
  control,
  optionsCargos,
  optionsSituacoes,
  optionsSetores,
  optionsCondicao,
  handleChange,
  handleSubmit,
  getValues,
  onSubmit,
  disabled,
  isEditar = false,
}) {
  const history = useHistory();
  const dispatch = useDispatch();

  const atendenteDetalhar = useSelector(state => state.atendente?.atendenteDetalhar);
  const atendenteLogado = useSelector(state => state.atendente?.atendenteLogado);
  const user = useSelector(state => state.sefaz.userProfile);

  const [exibirEditarApagar, setExibirEditarApagar] = useState(true);
  const [exibirOpcoesSetores, setExibirOpcoesSetores] = useState(false);
  const [exibirVariosSetores, setExibirVariosSetores] = useState(false);

  const deletarAtendente = () => dispatch(fetchDeletarAtendente(atendenteDetalhar?.id, history));

  React.useEffect(() => {
    const { multiplosSetores, opcoesSetores } = verificarOptionsSetores(getValues()?.cargo, getValues()?.setoresIds);
    setExibirVariosSetores(multiplosSetores);
    setExibirOpcoesSetores(opcoesSetores);
  }, [getValues]);

  React.useEffect(() => {
    if (atendenteLogado?.isSetorial) {
      dispatch(fetchGetAtendenteById(atendenteLogado?.id, null, false)).then(res => {
        dispatch(fetchAtendenteLogado({ ...atendenteLogado, setores: res.setores }));
      });
    }
    // eslint-disable-next-line
  }, [dispatch]);

  React.useEffect(() => {
    setExibirEditarApagar(verificarPermissaoEditarApagar(user));
  }, [user]);

  const handleValidarCargo = valorSelecionado => {
    validarCargo(valorSelecionado, handleChange, setExibirOpcoesSetores, setExibirVariosSetores);
  };

  return (
    <S.ContainForm>
      <Style.GlobalCard>
        <Row>
          <Col xs={24} sm={5} md={5} lg={5} xl={5}>
            <S.DescricaoAtendente>{getMensagem(disabled, atendenteLogado?.isSetorial)}</S.DescricaoAtendente>
            {disabled && exibirEditarApagar && (
              <S.ContainButton>
                <Button text={'Editar'} clickAction={() => history.push(editarAtendente)} />
                <Button
                  text={'Deletar'}
                  clickAction={() => openModalConfirmacao({ funcSuccess: deletarAtendente })}
                  css={{ corSecundaria: '#ffffff', cor: '#C62828' }}
                />
              </S.ContainButton>
            )}

            <InputText
              label="* CPF"
              name="cpf"
              errors={errors}
              placeholder={'CPF'}
              control={control}
              onChange={e =>
                handleChange({
                  target: {
                    name: 'cpf',
                    value: cpfMask(e.target.value),
                  },
                })
              }
              maxLength={14}
              disabled={disabled || isEditar}
            />
            <InputText
              label="* Nome"
              name="nome"
              errors={errors}
              placeholder={'Nome'}
              control={control}
              onChange={handleChange}
              maxLength={150}
              disabled={disabled}
            />
            <InputText
              label="* Apelido"
              name="apelido"
              errors={errors}
              placeholder={'Nome exibido para o contribuinte'}
              control={control}
              onChange={handleChange}
              maxLength={15}
              disabled={disabled}
            />
            <InputText
              label="* E-mail"
              name="email"
              errors={errors}
              placeholder={'E-mail'}
              control={control}
              onChange={handleChange}
              maxLength={100}
              disabled={disabled}
            />
            <InputSelect
              label="* Cargo"
              name="cargo"
              errors={errors}
              placeholder={'Cargo'}
              control={control}
              options={optionsCargos}
              disabled={disabled || atendenteLogado?.isSetorial}
              viewChange={handleValidarCargo}
            />
            <InputSelect
              label="* Situação"
              name="situacaoId"
              errors={errors}
              placeholder={'Situação'}
              control={control}
              options={optionsSituacoes}
              disabled={disabled}
            />
            {exibirOpcoesSetores && optionsSetores?.length > 0 && (
              <Setorial
                errors={errors}
                control={control}
                handleChange={handleChange}
                optionsSetores={filtrarSetores(optionsSetores, atendenteLogado?.setores)}
                disabled={disabled}
                bloquearInputAtendenteSetorial={
                  getValues()?.cargo === ENUM_CARGO.SUPERVISOR_SETORIAL || atendenteLogado?.isSetorial
                }
                exibirVariosSetores={exibirVariosSetores}
                getValues={getValues}
              />
            )}
            <InputSelect
              label="* Condição Status"
              name="condicaoStatusId"
              errors={errors}
              placeholder={'Condição Status'}
              control={control}
              options={optionsCondicao}
              disabled={user?.profile !== ENUM_TIPO_PERFIL.SUPERVISOR || disabled}
            />
            {!disabled && (
              <S.ContainButton>
                <Button text={'Salvar'} clickAction={handleSubmit(onSubmit)} disabled={disabled} />
              </S.ContainButton>
            )}
          </Col>
          <Col xs={24} sm={16} md={16} lg={16} xl={16} style={{ margin: 'auto' }}>
            <S.ImagemAtendente src={ImagemAtendente} alt={altImageAtendente} />
          </Col>
        </Row>
      </Style.GlobalCard>
    </S.ContainForm>
  );
}
